module.exports = __webpack_public_path__ + "img/onboarding_4.9205854a.png";